<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
  </div>
</template>

<script>
export default {
  computed: {
    items() {
      let labels = [];
      if (
        typeof this.$store.getters[
          `breadcrumb/${this.$route.meta.breadcrumb}`
        ] !== "undefined"
      ) {
        labels = JSON.parse(
          JSON.stringify(
            this.$store.getters[`breadcrumb/${this.$route.meta.breadcrumb}`]
          )
        );
        for (let i = 0; i < labels.length; i++) {
          labels[i].text = this.$t(`${labels[i].text}`);
        }
      }

      return labels;
    }
  }
};
</script>

<style scoped>
a {
  color: #3c4b64;
}

.breadcrumb {
  margin: 0;
  border: none;
}
</style>
